module.exports = __webpack_public_path__ + "static/19-743834a2d31c8e4d07864ca7cff29025.gif";